import { SelectorsFactory } from '../factories/selectors.factory';

export class PitchesSelectors extends SelectorsFactory {
  // eslint-disable-next-line no-underscore-dangle
  _byId(id) {
    const { sliceName } = this;
    return (state) => state[sliceName].list.find((e) => e.pitchId === id);
  }
}

export const pitchesSelectors = new PitchesSelectors('pitches');
